// src/components/ui/Textarea.jsx
import React from "react";

export const Textarea = React.forwardRef(({ label, name, value, onChange, ...props }, ref) => {
  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block text-sm font-medium mb-1">
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        ref={ref}
        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        rows={4}
        {...props}
      />
    </div>
  );
});